const BUFFET_START_TIMES = {
  '10:00:00': '10:00',
  '10:30:00': '10:30',
  '11:00:00': '11:00',
  '11:30:00': '11:30',
}

const BUFFET_END_TIMES = {
  '14:00:00': '14:00',
  '15:00:00': '15:00',
  '16:00:00': '16:00',
  '17:00:00': '17:00',
  '17:30:00': '17:30',
}

type Company = {
  id: string
  name: string
}

export type Station = {
  id: string
  name: string
  address: string
  buffetGroup: number // 0...4,
  incentiveSaleUnit: 'eur' | 'kpl'
  openingTime?: any // TODO: find out how to represent opening times
  buffetStartTime: keyof typeof BUFFET_START_TIMES
  buffetEndTime: keyof typeof BUFFET_END_TIMES // maybe more
  company: Company
}

/*
- Toimipaikan perustiedot, jos on
- Noutopöydän aukioloajat
- Onko yövuoroa
- Ruokalistakiertoryhmä (excel: yksikkö jako ryhmiin)
- Aloitteellisen myynnin seurannan yksikkö: kpl / €
*/

export type User = Record<string, any>

export interface ChainReminder {
  readonly id: string
  readonly name: string
  readonly time: string
  readonly weekdays: string[]
}

export interface StationChainReminder extends ChainReminder {
  readonly chainReminderStationId: string
  readonly disabled: boolean
  readonly muted: boolean
}

interface CheckListItem {
  days: Array<string>
  description: string
  id: string
  shiftStatus: {
    evening: string
    morning: string
    night: string
  }
  station: { id: string }
  type: Array<string>
}

export interface ChecklistItemEdge {
  node: CheckListItem
}

export interface ContinuingChecklistItemType {
  id: string
  description: string
  station: {
    id: string
  }
  type: string
  interval: number
}

export const weekDaysMap = {
  Monday: 'mon',
  Tuesday: 'tue',
  Wednesday: 'wed',
  Thursday: 'thu',
  Friday: 'fri',
  Saturday: 'sat',
  Sunday: 'sun',

  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
} as const

export type WeekDaysType = Record<'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun', boolean>

export const weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const
export const defaultValues = Object.assign({}, ...weekdays.map((weekday) => ({ [weekday]: false })))
